// API configuration
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

if (!API_BASE_URL) {
  throw new Error(
    'REACT_APP_API_BASE_URL environment variable is required. ' +
    'Please create a .env file in the ui/trouveai directory with: ' +
    'REACT_APP_API_BASE_URL=https://nationgraphapi.trouve.ai'
  );
}

// Helper function to get WebSocket URL
export const getWebSocketURL = (endpoint) => {
  const baseUrl = API_BASE_URL.replace(/^https?:\/\//, ''); // Remove http/https protocol
  const protocol = API_BASE_URL.startsWith('https') ? 'wss' : 'ws';
  return `${protocol}://${baseUrl}/${endpoint}`;
};

// Helper function to get HTTP URL
export const getHttpURL = (endpoint) => {
  return `${API_BASE_URL}/${endpoint}`;
};

export default API_BASE_URL;
